var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.4V16.8C0 18.12 1.08 19.2 2.4 19.2H19.2L24 24V2.4C24 1.08 22.92 0 21.6 0H2.4C1.08 0 0 1.08 0 2.4ZM9 6.6C9 7.56 8.16 8.4 7.2 8.4C6.24 8.4 5.4 7.56 5.4 6.6C5.4 5.64 6.24 4.8 7.2 4.8C8.16 4.8 9 5.64 9 6.6ZM18.6 6.6C18.6 7.56 17.76 8.4 16.8 8.4C15.84 8.4 15 7.56 15 6.6C15 5.64 15.84 4.8 16.8 4.8C17.76 4.8 18.6 5.64 18.6 6.6ZM5.28 10.8H18.84C17.88 13.56 15.24 14.4 12.12 14.4C9 14.4 6.24 13.56 5.28 10.8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.834d91efcd9e4738b752cb329e690584.svg";
export { ForwardRef as ReactComponent };